import { WidgetInstance, localizations } from 'friendly-challenge'

export function getCaptcha(container, sitekey, captchaToken, loading) {
    return new WidgetInstance(container, {
        sitekey,
        startMode: 'none',
        language: {
            ...localizations.fr,
            button_start: "Cliquez ici pour confirmer",
        },
        doneCallback: (solution) => {
            loading.value = false
            captchaToken.value = solution
        },
        errorCallback: (err) => {
            console.log('There was an error when trying to solve the Captcha.', err)
        },
    })
}

export default {
    methods: {
        initExtLinks() {
            document.querySelectorAll('a.newtab').forEach(function (elt) {
                elt.addEventListener('click', function (evt) {
                    evt.preventDefault()
                    window.open(this.href)
                })
            })
        },
        formatInclusion(period) {
            if (!period) {
                return ''
            }
            const m = period.toString().match(/(\d{4})(\d)/) // YYYYS
            return (m[2] === '1' ? 'Premier' : 'Second') + ' semestre ' + m[1]
        },
        checkPassword(password) {
            const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{12,30}$/; // ≥12 caractères, max 30 caractères, minuscule, majuscule, chiffre, spécial
            return PASSWORD_REGEX.test(password)
        },
        formatDate(date) {
            if (date) {
                const d = new Date(date)
                const txt = ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear()
                return txt
            }
            return '-'
        },
        warnDate(date) {
            const today = new Date()
            const cmpDate = new Date(date)
            return cmpDate - today < 60 * 24 * 60 * 60 * 1000 // 60 days in milliseconds
        }
    },
}
